/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_Plain_Firefox_AdaptInputs */

const en_actual_plain_firefox_adapt = /** @type {(inputs: Actual_Plain_Firefox_AdaptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No neutrals`)
};

const de_actual_plain_firefox_adapt = /** @type {(inputs: Actual_Plain_Firefox_AdaptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Neutralen`)
};

/**
* | output |
* | --- |
* | "No neutrals" |
*
* @param {Actual_Plain_Firefox_AdaptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const actual_plain_firefox_adapt = /** @type {((inputs?: Actual_Plain_Firefox_AdaptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_Plain_Firefox_AdaptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actual_plain_firefox_adapt(inputs)
	return de_actual_plain_firefox_adapt(inputs)
});